/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import _find from 'lodash/find'
import {useSelector} from 'react-redux'
import _forEach from 'lodash/forEach'
import _isEmpty from 'lodash/isEmpty'

export const transformInfo = (it) => {
  if (_isEmpty(it)) {
    return {}
  }
  const privileges = []
  _forEach(it?.privileges, (item) => {
    _forEach(item?.medals || item?.ra_medal_list, (v) => {
      const url = v.icon || v.dmk_icon || v.icon_v2
      if (url) {
        privileges.push(url)
      }
    })
  })
  return {
    privileges,
    country: it?.flag?.url,
    id: it?.mid,
    name: it?.member?.name,
    avatar: it?.member?.avatar_urls?.aspect_low?.urls?.[0],
  }
}

export const pay_bind_list_by_mid = createAsyncThunk(
  'CoinAgencyCollectSalary/pay_bind_list_by_mid',
  async (arg: any, store: any) => {
    const {h_m: mid} = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/union/pay_bind_list_by_mid',
      {
        mid,
        channel_type: 400,
        ...arg,
      },
      {store, xcErrorToast: true}
    )
    const tmp =
      _find(resp.data.data?.list || [], (it) => it.channel_type === 400) || {}
    return Number(tmp?.channel_account)
  }
)
export const pay_bind = createAsyncThunk(
  'CoinAgencyCollectSalary/pay_bind',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/pay_bind',
      {
        ...p,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const get_merchant_info = createAsyncThunk(
  'CoinAgencyCollectSalary/get_collection_merchant_list',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/get_collection_merchant_list',
      {
        offset: 0,
        limit: 10,
        page_size: 10,
        is_ignore_status: true,
        search_mid: p.search_mid,
      },
      {store, xcErrorToast: true}
    )
    return transformInfo((resp.data.data?.list || [])[0])
  }
)

// 主播/币商 处理订单
export const handle_collection_order_from_app = createAsyncThunk(
  'CoinAgencyCollectSalary/handle_collection_order_from_app',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/handle_collection_order_from_app',
      {
        ...p,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

// 发生争议
export const handle_dispute_collection_order_event = createAsyncThunk(
  'CoinAgencyCollectSalary/handle_dispute_collection_order_event',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/handle_dispute_collection_order_event',
      {
        ...p,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_merchant_channel_setting_cfgs = createAsyncThunk(
  // [获取币商代收收款渠道配置列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=173834545
  'CoinAgencyCollectSalary/live/union/get_merchant_channel_setting_cfgs',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/get_merchant_channel_setting_cfgs',
      {
        ...p,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const update_merchant_pay_out_account = createAsyncThunk(
  // [增加/更新/删除 币商代收渠道信息] http://wiki.xunlei.cn/pages/viewpage.action?pageId=173834558
  'CoinAgencyCollectSalary/live/union/update_merchant_pay_out_account',
  async (p: {action: 1 | 2 | 3; account?: any}, store: any) => {
    // 1 增加 2 更新 3 删除
    const resp = await http.post(
      '/live/union/update_merchant_pay_out_account',
      {
        ...p,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const set_merchant_pay_out_account_default = createAsyncThunk(
  // [设置代收渠道为默认] http://wiki.xunlei.cn/pages/viewpage.action?pageId=174031300
  'CoinAgencyCollectSalary/live/union/set_merchant_pay_out_account_default',
  async (p: {pay_out_account_id: string | number}, store: any) => {
    const resp = await http.post(
      '/live/union/set_merchant_pay_out_account_default',
      {
        ...p,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_merchant_pay_out_channel_list = createAsyncThunk(
  // [获取币商代收收款渠道用户填写列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=173834547
  'CoinAgencyCollectSalary/live/union/get_merchant_pay_out_channel_list',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/get_merchant_pay_out_channel_list',
      {
        ...p,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  client: any
  payment?: {
    channel_account_cfgs?: {
      id: number // 配置id
      areaCode: number // 区域
      channel: string // 渠道名字
      icon: string // 图标
      fields: {
        key: string // 中文key
        value: string // 英文
        isRequired: boolean // 是否必填
      }[]
    }[]
    list?: any[]
  }
}

const initialState: InitialStateType = {
  client: {},
}

export const CoinAgencyCollectSalarySlice = createSlice({
  name: 'Animal_Crane',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_merchant_info.fulfilled, (state, action) => {
      Object.assign(state, {
        client: action.payload,
      })
    })
    builder.addCase(
      get_merchant_channel_setting_cfgs.fulfilled,
      (state, action) => {
        Object.assign(state, {
          payment: {
            ...state.payment,
            ...action.payload,
          },
        })
      }
    )
    builder.addCase(
      get_merchant_pay_out_channel_list.fulfilled,
      (state, action) => {
        Object.assign(state, {
          payment: {
            ...state.payment,
            ...action.payload,
          },
        })
      }
    )
  },
})
export default CoinAgencyCollectSalarySlice.reducer
export const CoinAgencyCollectSalaryActions =
  CoinAgencyCollectSalarySlice.actions

export const useCoinAgencyCollectSalaryState = () => {
  const data = useSelector((state) => {
    return state.Animal_Crane
  })
  return data
}
